
const home = {
  // Header nav
  nav_top: 'Home',
  nav_about: 'About DRA',
  nav_dreamcode: 'DREAM CODE',
  nav_cases: 'Case Studies',
  nav_implementation: 'Implementation',
  nav_awards: 'Awards',
  nav_contact: 'CONTACT',
  nav_contact_sub: 'Contact Us',

  // Hero
  hero_badge: 'International Education Excellence Award – New York',
  hero_title: 'Unlocking Human Potential\nThrough Science and Educational Structure.',
  hero_subtitle: 'DREAM CODE is an educational framework\nthat designs growth from its very structure.',
  hero_cta: 'What is DREAM CODE?',

  // About
  about_label: 'ABOUT DRA',
  about_title: 'An Institution That Works with Structure',
  about_body1: 'Dream Realization Academy (DRA) is an institution\nthat organizes the mechanisms of human thought and behavior\nfrom a scientific perspective and presents them as a reproducible educational system.',
  about_body2: 'We work with structure, not motivation.',
  about_body3: 'Toward a society where effort is not left to chance.',
  about_cta: 'About DRA',

  // Dream Code
  dreamcode_title: 'Not just understanding.\nEmbedding through experience.',
  dreamcode_body: 'A systematic educational program consisting of 48 courses.\nThrough a cyclical design of learning, experiencing, reflecting, and embedding,\nit generates sustainable change.',
  dreamcode_cta: 'Explore DREAM CODE',

  // Four Stages
  stage1_title: 'Foundation',
  stage1_subtitle: 'Self-Understanding',
  stage1_desc: 'Scientifically understand your own thinking patterns and behavioral structures to build the foundation for growth.',
  stage2_title: 'Reconstruction',
  stage2_subtitle: 'Cognitive Redesign',
  stage2_desc: 'Deconstruct existing thinking frameworks and redesign them into more effective cognitive structures.',
  stage3_title: 'Future Design',
  stage3_subtitle: 'Strategy Building',
  stage3_desc: 'Systematically build clear goal-setting and concrete strategies to achieve them.',
  stage4_title: 'Autonomous Growth',
  stage4_subtitle: 'Sustainable Development',
  stage4_desc: 'Internalize self-correction functions and establish a mechanism for continuous growth while adapting to environmental changes.',

  // Application
  app_label: 'APPLICATION AREAS',
  app_title: 'Areas of Application',
  app1_title: 'Individuals',
  app1_desc: 'Provides a structural approach to career development, self-realization, and life planning.',
  app2_title: 'Corporations',
  app2_desc: 'Builds a scientific foundation for organizational development, leadership cultivation, and team building.',
  app3_title: 'Educational Institutions',
  app3_desc: 'Maximizes learning outcomes, systematizes educational programs, and advances teacher training.',

  // Founder
  founder_title: "Founder's Message",
  founder_lead: 'Why do we work with "structure"?',
  founder_role: 'Founder, Dream Realization Academy',
  founder_name: 'Shinji Hirose',

  // Awards
  awards_label: 'AWARDS & RECOGNITION',
  awards_title_sub: '── Recognized by the World',
  awards_body: 'In 2026, New York. We were honored with the "Award for Outstanding Contribution" by a Special Consultative Status organization of the United Nations Economic and Social Council, in recognition of our achievements in education and social development.',
  awards_cta: 'Learn More',
  awards_badge_title: 'International Education\nExcellence Award',
  awards_badge_year: 'New York 2026',

  // CTA
  cta_individual: 'Explore as an Individual',
  cta_corporate: 'Consult About Implementation',

  // Footer sections
  footer_about_title: 'About DRA',
  footer_about_link1: 'About DRA',
  footer_about_link2: 'Founder',
  footer_about_link3: 'Philosophy',
  footer_program_title: 'Program',
  footer_program_link1: '48 Courses',
  footer_program_link2: 'Case Studies',
  footer_intro_title: 'Implementation',
  footer_intro_link1: 'For Individuals',
  footer_intro_link2: 'For Corporations',
  footer_intro_link3: 'For Educational Institutions',
  footer_other_title: 'Other',
  footer_other_link1: 'Awards & Activities',
  footer_other_link2: 'Contact',
  footer_other_link3: 'Privacy Policy',
};

export default home;
